/**
 * THE PROJECTS A TIMESHEET WEEK TOUCHES.
 *
 * Its own module for two reasons: it must be importable by a test without
 * pulling Firestore in behind it, and `scripts/backfill-timesheet-index.py`
 * reimplements it in Python. If the two ever disagree, the index silently
 * stops finding weeks — so `test/timesheet-index.test.mjs` runs both against
 * the same fixtures and fails if they part company.
 *
 * A row may be matched by either its project id or its project number (project
 * detail matches on both, because older rows carry only the number), so both go
 * in. Insertion-ordered and de-duplicated, so a re-run of the backfill compares
 * equal to itself and skips instead of rewriting the whole collection.
 */
export function timesheetProjectKeys(rows) {
  const keys = [];
  for (const r of (rows || [])) {
    if (!r || typeof r !== 'object') continue;
    if (r.projectId) {
      const id = String(r.projectId);
      if (!keys.includes(id)) keys.push(id);
    }
    const no = r.number == null ? '' : String(r.number).trim();
    if (no && !keys.includes(no)) keys.push(no);
  }
  return keys;
}
